import React, { useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { updateCommonInfo } from "../../redux/commonSlice";
import { httpGetConfigValues } from "../../service/httpClient";
import * as _ from "../../constants/Constants";
import {
  ALL,
  NONE,
  VENDORPLATFORM_SHIPPING_LOCATIONDETAILS,
} from "../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../utils/rolePermissionAccess";
import { TooltipIcon } from "../../assets/js/image";

const RoutingRequest = (props) => {
  const dispatch = useDispatch();
  const store = useSelector(
    ({ service, common }) => ({
      configValues: common.configValues,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (store?.configValues?.length === 0) {
      httpGetConfigValues()
        .then((response) => {
          dispatch(
            updateCommonInfo({
              configValues: response.data,
            })
          );
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const getResourceRoutingURL = () => {
    const configValues = store?.configValues || [];
    const configValue = configValues.filter(
      (item) => item.key === "shipping_routing_link"
    );
    if (configValue && configValue.length > 0) {
      return configValue[0].value;
    }
    return "#";
  };

  return (
    <div>
      <div className="shipping-location-title">
        <div style={{ padding: "10px" }}>
          {_.VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS}
        </div>
        <TooltipIcon style="shipping-location-title-icon"></TooltipIcon>
      </div>

      <div style={{ fontWeight: "bold", padding: "20px" }}>
        Click on
        {getUserRolePermission(VENDORPLATFORM_SHIPPING_LOCATIONDETAILS, ALL) ===
        NONE ? (
          <span
            className="linkStyle"
            style={{
              color: "rgb(19, 149, 197)",
              fontSize: "1rem",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            {_.VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS}
          </span>
        ) : (
          <a
            href={getResourceRoutingURL()}
            className="linkStyle"
            target="_blank"
            style={{
              marginLeft: "5px",
              color: "rgb(19, 149, 197)",
              fontSize: "1rem",
              marginRight: "5px",
            }}
          >
            {_.VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS}
          </a>
        )}
        {_.ROUTING_REQUEST_MESSAGE}
      </div>
    </div>
  );
};

export default RoutingRequest;
